import React, { useState, useEffect } from 'react';
import * as Helpers from "../../../global/Helpers";
import { useTranslation } from "react-i18next";
import { ComponentChildCode } from '../../../constants/Constants';
import About from './About';
import News from './News';


import '../CopyPeopleProfile.css'


const Feed = (props) => {
    const { i18n } = useTranslation();

    const DefaultOpen = 1;
    const [openedTab, setOpenedTab] = useState(DefaultOpen);


    /* Transfer component mounted */
    useEffect(() => {
        /* componentDidMount */

        openTab(null, DefaultOpen);
    }, [])

    let ml2Localized = "ml-2";
    let leftLocalized = "left";
    let dir = "ltr";
    var height = "150px";

    if (Helpers.getIsIPad()) {
        height = "185px";
    }

    if (i18n.language === "ar") {
        ml2Localized = "mr-2";
        leftLocalized = "right";
        dir = "rtl";
    }

    function openTab(evt, tab) {
        var i, tablinksCopyPeople;
        setOpenedTab(tab);
        tablinksCopyPeople = document.getElementsByClassName("Feedtablinks");

        for (i = 0; i < tablinksCopyPeople.length; i++) {
            tablinksCopyPeople[i].className = tablinksCopyPeople[i].className.replace(" active", "");
        }
        if (tablinksCopyPeople.length !== 0)
            if (evt) {
                evt.currentTarget.className += " active";
            } else {
                tablinksCopyPeople[0].className += " active";
            }
    }
    return (
        <>


            <div className="tab-custom" style={{ width: "50%", paddingInline: "1%" ,backgroundColor: "transparent"  }} >
                <div style={{ float: leftLocalized }}>
                    <button className="Feedtablinks" onClick={(e) => openTab(e, 1)} >
                        <strong className="lableCustomized">  {i18n.t("newsTitle")} </strong>
                    </button>

                    <button className="Feedtablinks" onClick={(e) => openTab(e, 2)}>

                        <strong className="lableCustomized">  {i18n.t("About")} </strong>
                    </button>
                </div>
            </div>

            <div style={{ height: "calc(100% - " + height + ")" }}>
                {
                    openedTab === 1
                        ? <div style={{ height: "calc(100% + 95px)", overflowY: "auto" }}>
                            <News
                                screenid={props.screenid}
                            />
                        </div>

                        : openedTab === 2
                            ?
                            <div style={{ height: "calc(100% + 90px)", overflowY: "auto" }}>
                                <About 
                                 isDarkMode={props.isDarkMode}
                                 />
                            </div>



                            : null

                }
            </div>

        </>
    );
};

export default Feed;